import { render, staticRenderFns } from "./props-view.vue?vue&type=template&id=18b1fdae&"
import script from "./props-view.vue?vue&type=script&lang=js&"
export * from "./props-view.vue?vue&type=script&lang=js&"
import style0 from "./props-view.vue?vue&type=style&index=0&id=18b1fdae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports